import styled from 'styled-components';
import theme from '@/data/theme';

interface EmptyErrorProps {
  $emptyError?: string;
  $disabled?: boolean;
}

const StyledInputField = styled.input<EmptyErrorProps>`
  border: 1px solid ${({ $emptyError }) => ($emptyError ? '#ff4d4f' : '#edeef1')};
  padding: 0.6rem;
  width: 100%;
  border-radius: 5px;
  font-family: ${theme.fonts.primary};

  font-size: 12px;
`;
const StyledTextAreaField = styled.textarea`
  border: 1px solid #b6bac3;
  padding: 10px;
  width: 100%;
  border-radius: 5px;
  resize: none;
  height: 100px;
  font-size: 12px;
  font-family: ${theme.fonts.primary};
`;

const StyledInputLabel = styled.label`
  color: ${theme.colors.black};
  font-size: 12px;
  font-weight: 500;
`;

const LabelInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const StyledSavedButton = styled.button`
  color: ${theme.colors.primary};
  width: 100%;
  border: none;
  background-color:rgba(134, 92, 208, 0.3);
  padding: 0.625rem 1.25rem;
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
    font-family: ${theme.fonts.primary};

}
`;
const StyledFilledBorderButton = styled.button`
  color: ${theme.colors.primary};
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.primary};
  padding: 0.625rem 1.25rem;
  border-radius: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  width: 100%;
  cursor: pointer;
  font-family: ${theme.fonts.primary};
`;

const StyledModalHeader = styled.h2`
  color: ${({ theme }) => theme.colors.black};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
const StyledModalTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledModalTitleButtonWrapper = styled.div`
  display: flex;
  gap: 0.25rem;
`;

const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 0.65rem;
`;

const StyledEditModalButtonWrapper = styled.div`
  width: 100%;
`;

const TableBookingDetailPhoneInputWrapper = styled.div<EmptyErrorProps>`
  height: 40px;
  padding: 0;
  border: 0.8px solid ${({ $emptyError }) => ($emptyError ? '#F43434' : '#b6bac3')};
  box-shadow: ${({ theme }) => theme.shadows.inputFieldShadow};
  border-radius: 5px;
  font-family: ${theme.fonts.primary};

  &:focus-within {
    border: 2px solid ${({ theme }) => theme.colors.primary};
  }

  & .PhoneInput {
    height: 100%;
    border-radius: 5px;
    outline: none;
    color: #b6bac3;
  }

  & .PhoneInputCountry {
    height: 100%;
    padding: 0 14px;
    margin: 0 !important;
    border: none;
    gap: 5px;
    cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  }

  & .PhoneInputInput {
    padding: 0 15px;
    border-radius: 0 5px 5px 0;
    margin-left: 2px;
    height: 100%;
    border-left: 1px solid #d9d9d9;
    border-right: none;
    border-top: none;
    border-bottom: none;
    color: ${(props) => (props.$disabled ? '#b6bac3 ' : 'black')};
    outline: none;
    cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'text')};
  }

  & .PhoneInputCountryIcon--border {
    box-shadow: none !important;
  }

  & .PhoneInputCountrySelectArrow {
    margin-left: 0;
    cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  }

  & .PhoneInputCountryIcon {
    width: 86%;
    height: 100%;
    padding: 5px 0;
    background-color: white;
  }

  &&::placeholder {
    color: black;
    opacity: 1;
  }
`;
const StyledBottomButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 1rem;
`;
export {
  StyledInputLabel,
  StyledInputField,
  StyledSavedButton,
  StyledFilledBorderButton,
  StyledTextAreaField,
  StyledModalHeader,
  StyledButtonWrapper,
  StyledEditModalButtonWrapper,
  TableBookingDetailPhoneInputWrapper,
  StyledModalTitleWrapper,
  StyledBottomButtonWrapper,
  StyledModalTitleButtonWrapper,
  LabelInputWrapper,
};
